import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import {
  purchaseTransactionApi,
  purchaseTransactionLabel,
  purchaseTransactionStatic,
} from "./fxTransactionPurchase.config";

const { Text, Title } = Typography;
const { detailPurchaseTransactionItems, monthList, transactionTypeData } =
  purchaseTransactionStatic;

const ViewPRD0600 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [purchaseTransactionDetail, setPurchaseTransactionDetail] = useState(
    {},
  );
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCurrencies();
    getLocalCurrencies();
    getDetailById();
  }, []);

  function getCurrencies() {
    const url = `${purchaseTransactionApi.GetCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempValue = objList;
        // setLocalCurrencyData(tempValue);
      }
    });
  }

  function getLocalCurrencies() {
    const url = `${purchaseTransactionApi.GetLocalCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempEquityData = [];

        // objList.forEach((element) => {
        //   tempEquityData.push({
        //     value: element.id,
        //     label: element.name,
        //     code: element.glCode,
        //   });
        // });

        // setEquityData(tempEquityData);
      }
    });
  }

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${purchaseTransactionApi.purchaseTransaction}/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setPurchaseTransactionDetail(objDetail);
        setIsLoading(false);

        const transactionTypeLabel =
          (
            transactionTypeData.find(
              (type) => type.value === objDetail.transactionType,
            ) || {}
          ).label || "Unknown";

        setInputField([
          {
            name: purchaseTransactionLabel.transactionDate,
            value: objDetail.transactionDate
              ? `${objDetail?.transactionDate[2]} ${
                  monthList[objDetail?.transactionDate[1] - 1]
                } ${objDetail?.transactionDate[0]}`
              : "-",
          },
          {
            name: purchaseTransactionLabel.amountACY,
            value: objDetail.transactionAmount,
          },
          {
            name: purchaseTransactionLabel.accountNo,
            value: objDetail.savingsAccountNo,
          },
          {
            name: purchaseTransactionLabel.transactionType,
            value: transactionTypeLabel,
          },
          {
            name: purchaseTransactionLabel.accountName,
            value: objDetail.customerName,
          },
          {
            name: purchaseTransactionLabel.accountCurrency,
            value: objDetail.accountCurrencyCode,
          },
          {
            name: purchaseTransactionLabel.transactionCCY,
            value: objDetail.transactionCurrencyCode,
          },
          {
            name: purchaseTransactionLabel.amountLCY,
            value: objDetail.localCurrencyAmount,
          },
          {
            name: purchaseTransactionLabel.amountTCY,
            value: objDetail.accountCurrencyAmount,
          },
          {
            name: purchaseTransactionLabel.charge,
            value: objDetail.charge ? objDetail.charge.name : "-",
          },
          {
            name: purchaseTransactionLabel.currencyRate,
            value: objDetail.exchangeRate,
          },
        ]);
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={purchaseTransactionLabel.purchaseTransactionDetail}
        pageItems={detailPurchaseTransactionItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {purchaseTransactionLabel.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={item.value}
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPRD0600);
